const telegram = window.Telegram.WebApp;

export const initTelegramApp = () => {
  telegram.ready();
  telegram.expand();
};

export const getUserData = () => {
  return telegram.initDataUnsafe?.user || {};
};

export const closeTelegramApp = () => {
  telegram.close();
};

export default telegram;